export enum ServiceActivationCodeEnum {
  NOT_ACTIVATED = 'NOT_ACTIVATED',
  SUBSCRIPTION_IN_PROGRESS = 'SUBSCRIPTION_IN_PROGRESS',
  ACTIVATED = 'ACTIVATED',
}
